import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";



const Section5 = () => {
  const { t } = useTranslation();
  
  return (
    <motion.div 
    initial="hidden"
    whileInView="visible"
    exit="exit"
    variants={containerVariants}
    className="grid grid-cols-10">
      <div className="col-start-2 md:col-start-2 col-span-8 md:col-span-6 ">
        <div className="my-28  ">
          <motion.h1   variants={itemVariants} className=" text-65  text-customBlack mb-5 font-medium">
            {t("sustainability.environmental.title")} <span className="font-light">{t("sustainability.environmental.subtitle")}</span>
          </motion.h1>
          <motion.p   variants={itemVariants} className="text-20 font-medium text-customGray5 mb-14">
            {t("sustainability.environmental.text1")}
          </motion.p>

          <motion.p   variants={itemVariants} className="text-20 font-light text-customGray5">
            {t("sustainability.environmental.text2")}
          </motion.p>
        </div>
      </div>
    </motion.div>
  );
};

export default Section5;
